import { Http } from "@/net/Http";
import { Urls } from "@/net/Urls";
import { UserLocalStorage } from "@/service/user.localstorge";
import { openToast } from "toast-ts";

export interface WecahtOpenID {
  access_token: number;
  openid: string;
}

export interface WecahtUserInfo {
  openid: string;
  city: string;
  country: string;
  headimgurl: string;
  language: string;
  nickname: string;
  province: string;
  sex: string;
  unionid: string;
}

export class WXLogin {
  static cherryAppID = "wx9cfc7d9830c28c65";
  static cherryGetOpenIDKey = "cherryGetOpenID";
  static cherryGetWechatInfoKey = "CherryGetWechatInfo";

  static login(isSnsapiBase: boolean, checkRedirectUrl: string) {
    let snsapi = "snsapi_base";
    let state = this.cherryGetOpenIDKey;
    if (isSnsapiBase == false) {
      snsapi = "snsapi_userinfo";
      state = this.cherryGetWechatInfoKey;
    }
    let uri = this.redirectUrl();
    uri = encodeURIComponent(checkRedirectUrl);
    // console.log("uri:", uri);
    const wechatUrl =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      this.cherryAppID +
      "&redirect_uri=https://center.cherry.cn/proxy/wechat_re?url=" +
      uri +
      "&response_type=code&scope=" +
      snsapi +
      "&state=" +
      state +
      "#wechat_redirect";
    window.location.href = wechatUrl;
  }

  static redirectUrl() {
    let uri = "";
    const locationHref = window.location.href;

    const cheekUrl = RegExp("^http.+?code=(.+?)&state=(.*?)$|&").exec(
      locationHref
    );
    if (cheekUrl) {
      const target = locationHref.indexOf("#");
      const query = locationHref.indexOf("?");
      const uri1 = locationHref.substring(0, query);
      if (target > -1) {
        const uri2 = locationHref.substring(target, locationHref.length);
        uri = uri1 + uri2;
      } else {
        uri = uri1;
      }
    } else {
      uri = locationHref;
    }
    return uri;
  }

  static checkUrl(callBack: Function) {
    const state = this.analysisURL("state");
    const code = this.analysisURL("code");
    // console.log("state:", state);
    // console.log("code:", code);
    if (state == this.cherryGetOpenIDKey) {
      this.getOpenIDByCode(code);
    }
    if (state == this.cherryGetWechatInfoKey) {
      this.getUserInfoByCode(code, callBack);
    }
  }

  static checkAuthorizeUrl(callBack: Function) {
    const code = this.analysisURL("code");
    // console.log("code:", code);
    this.getAuthorizeOpenIDByCode(code, callBack);
  }

  static getAuthorizeOpenIDByCode(code: string, callBack: Function) {
    const data = { code: code };
    // console.log("getAuthorizeOpenIDByCode->data:", data);
    Http.post<string>(Urls.activity_tanabata_wxopen, data).then(
      (res: string) => {
        // console.log(res)
        UserLocalStorage.setWXAuthorizeOpenid(res);
        callBack();
      },
      err => {
        openToast("登录失败");
        // console.log("getWecahtAuthorizeOpenID->err:", err);
        callBack();
      }
    );
  }

  static analysisURL(name: string) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return "";
  }
  static getOpenIDByCode(code: string) {
    const data = { code: code, type: "mp" };
    // console.log("getOpenIDByCode->data:", data);
    Http.postUser<WecahtOpenID>(Urls.getwxOpenid, data).then(
      (res: WecahtOpenID) => {
        UserLocalStorage.setWXOpenid(res.openid);
      },
      err => {
        openToast("登录失败");
        // console.log("getWecahtOpenID->err:", err);
      }
    );
  }

  static getUserInfoByCode(code: string, callBack: Function) {
    const data = { code: code, type: "mp" };
    Http.postUser<WecahtUserInfo>(Urls.getwxUserInfo, data).then(
      (res: WecahtUserInfo) => {
        UserLocalStorage.setWXUserData(res);
        // console.log("getWechatUserInfo->res:", res);
        callBack();
        // if (model.code == 0) {
        // storge.setKeyValue(cherryWxOpenID, model.data.openid);
        // storge.setKeyValue(cherryWxUnionID, model.data.unionid);
        // storge.setKeyValue(cherryWxName, model.data.nickname);
        // storge.setKeyValue(cherryWxAvatar, model.data.headimgurl);
      },
      err => {
        // console.log("getWechatUserInfo->err:", err);
        callBack();
      }
    );
  }
}
